export default {
  title: "SORU6",
  text: `Son yıllarda toplumumuzun görsel sanatlar sevgisinde bir kımıldanma görülüyor. Her sanat dalı yaşama açılan pencerelerden biridir. Pencereleri hepten kapanmış binada ömür geçirmeye tahammül edenler, ruh çölünde yaşıyor demektir. Çölden dışarı adım atanlar, yaşadıkları yerlerin duvarlarına resim asmaya, heykelle ilgilenmeye, fotoğraf çekmeye başladılar. Bu, övgüye değer!`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/6.js